<div>
    @if (!showEmail) {
        <div>
            <div class="body-color">
                <lh-header-bar
                    class="d-sm-none"
                    [content]="headerTitle"
                    [showBackButton]="redirectedFromSASWFlow ? false : true"
                    (onBack)="goBack(levelData, level, true)"
                    (onClose)="close(true, false)">
                </lh-header-bar>
                <ng-container *ngTemplateOutlet="focuscontactTemplate"></ng-container>
            </div>
            <!-- <lh-navigation-layout-page *ngIf="v2NavEnabled && loggedInUser" sourceItem="help" [topMenuVisibility]="newAccountMenuService.hideTopMenu('help')">
      <ng-container *ngTemplateOutlet="focuscontactTemplate"></ng-container>
    </lh-navigation-layout-page> -->
        </div>
    }
    @if (showEmail) {
        <div>
            @if (helpAndContactData.showEmailScreen) {
                <div id="contact-options">
                    <pt-email-option
                        [contactData]="emailScreenContactData"
                        [enableDragAndDrop]="initData.enableDragAndDrop"
                        [isNewDobEnabled]="initData.isNewDobEnabled"
                        (disableEmailScreen)="disableEmailScreen($event)">
                    </pt-email-option>
                </div>
            }
        </div>
    }

    <!-- This is app testing of k8 urls -->
    @if (!page.isProduction) {
        <div class="non-prod-banner">
            <h5>TESTING URLS</h5>
            <p>This section will only display for NON PROD areas and this is not an issue.</p>
            <div class="testing-links">
                @for (link of testingLinks; track link.key) {
                    <div class="link-item">
                        <a rel="noopener" [href]="link.url">{{ link.key }}</a>
                    </div>
                }
            </div>
        </div>
    }
</div>
<ng-template #focuscontactTemplate>
    <div class="new-contact-page-wrapper">
        @if (isDesktop && (!showEmail || showbreadcrumb)) {
            <div class="contact-bredcrumb">
                @if (!hideFirstLevel) {
                    <div class="main-heading">
                        <span
                            [ngClass]="{
                                'theme-left cursorPointer ui-icon ui-back':
                                    (initData.enableBackIcon && !hideFirstLevel && !optionsScreen && !redirectedFromSASWFlow) || isGuideEnabled,
                            }"
                            (click)="onback()"></span
                        >{{ firstLevelTitle }}
                    </div>
                }
                @if ((!hideSecondLevel || !hideContactPage) && hideThirdLevel) {
                    <div class="d-flex">
                        <div class="breadcrumb-item" (click)="clickedFirstLevel()">{{ firstLevelTitle }}</div>
                        <div class="theme-right"></div>
                        <div class="dh bread-crumb-font">
                            <!-- (click)="goBack(thirdLevelData, 'third')" -->
                            {{ secondLevelTitle }}
                        </div>
                    </div>
                }
                @if (!hideThirdLevel && !optionsScreen) {
                    <div class="d-flex">
                        <div class="breadcrumb-item" (click)="clickedFirstLevel(true)">{{ firstLevelTitle }}</div>
                        @if (secondLevelTitle != '') {
                            <div class="theme-right"></div>
                        }
                        @if (secondLevelTitle != '') {
                            <div class="breadcrumb-item" (click)="goBack(thirdLevelData, 'third')">
                                {{ secondLevelTitle }}
                            </div>
                        }
                        <div class="theme-right"></div>
                        @if (thirdLevelTitle) {
                            <div class="breadcrumb-item-article breadcrumb-item">{{ thirdLevelTitle }}</div>
                        }
                    </div>
                }
                @if (optionsScreen && !hideThirdLevel) {
                    <div class="d-flex">
                        <div class="breadcrumb-item" (click)="clickedFirstLevel()">{{ firstLevelTitle }}</div>
                        @if (secondLevelTitle != '') {
                            <div class="theme-right"></div>
                        }
                        @if (secondLevelTitle != '') {
                            <div class="breadcrumb-item" (click)="bindcategory(selectedItem, 0, 0, false, true)">
                                {{ secondLevelTitle }}
                            </div>
                        }
                        @if (thirdLevelTitle != '') {
                            <div class="theme-right"></div>
                        }
                        @if (thirdLevelTitle != '' && !thirdLevelData.fromHCC) {
                            <div class="breadcrumb-item-last breadcrumb-item" (click)="bindsubcategory(thirdLevelData)">
                                {{ thirdLevelTitle }}
                            </div>
                        }
                        @if (thirdLevelTitle != '' && thirdLevelData.fromHCC) {
                            <div class="breadcrumb-item-last breadcrumb-item" (click)="bindsubcategory(SelectedArticle, true)">
                                {{ thirdLevelTitle }}
                            </div>
                        }
                        @if (contactUsTitle != '') {
                            <div class="theme-right"></div>
                        }
                        @if (contactUsTitle != '') {
                            <div class="dh never-break bread-crumb-font">{{ messages?.ContactUs }}</div>
                        }
                    </div>
                }
            </div>
        }
        @if (initData.isEmergencyMsgPlacedTop && informationMessage && !showEmail && !emergencyMessageClosed) {
            <div class="message-panel">
                <div class="theme-info-i secondary Success msg position-info">
                    <div class="cms-container">
                        <div #infoContainer class="info-message" [ngClass]="{ 'show-full-message': showMore == false }">
                            <div [vnDynamicHtml]="informationMessage"></div>
                        </div>
                        <div class="row" [hidden]="hideShowMore">
                            <a class="link-external handle-content col paddingRight" href="" (click)="showmore()">
                                {{ showMore ? messages.ShowMore : messages.ShowLess }}
                            </a>
                            @if (isCloseIconEnabled && !emergencyMessageClosed) {
                                <a class="link-external handle-content" href="" [vnDynamicHtml]="messages.OkText" (click)="closeEmergencyMsg()"></a>
                            }
                        </div>
                        <div [hidden]="!hideShowMore">
                            @if (isCloseIconEnabled && !emergencyMessageClosed) {
                                <a class="link-external handle-content" href="" [vnDynamicHtml]="messages.OkText" (click)="closeEmergencyMsg()"></a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (initData.contactusTilePosition == 'top') {
            <ng-container *ngTemplateOutlet="contactusTile"></ng-container>
        }
        <div class="user-menu-wrapper">
            <div class="contact-header-title"></div>
            <div class="contact-header-title" [hidden]="hideRemaining">
                <div class="d-flex">
                    @if (isDesktop && (hideFirstLevel || showbreadcrumb || (optionsScreen && contactOptionsTileClick))) {
                        <div>
                            <div class="user-menu-item-end-icon" (click)="goBack(levelData, level, false, true)">
                                <span class="theme-left"></span>
                            </div>
                        </div>
                    }
                    @if (isDesktop && (hideFirstLevel || (optionsScreen && contactOptionsTileClick))) {
                        <div class="focus-contact-sub-heading">
                            {{ headerTitle }}
                        </div>
                    }
                    @if (initData.enablePromoCTA && showpromocta && isDesktop && (hideFirstLevel || (optionsScreen && contactOptionsTileClick))) {
                        <div class="cta-promo">
                            <div>
                                <button class="oval-link" (click)="promoctaEvent()"><i class="theme-offers-2"></i>{{ promoctalabel }}</button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
        @if (isMobile && !optionsScreen) {
            <div class="thirdleveltitlemobile" [hidden]="hideThirdLevel" [innerHtml]="copytitle"></div>
        }
        @if (!initData.isEmergencyMsgPlacedTop && informationMessage && !showEmail && !emergencyMessageClosed) {
            <div class="message-panel">
                <div class="theme-info-i secondary Success msg">
                    <div class="cms-container">
                        <!-- <h3>Information message</h3> -->
                        <div #infoContainer class="info-message" [ngClass]="{ 'show-full-message': showMore == false }">
                            <div [vnDynamicHtml]="informationMessage"></div>
                        </div>
                        <div class="row" [hidden]="hideShowMore">
                            <a class="link-external handle-content col paddingRight" href="" (click)="showmore()">
                                {{ showMore ? messages.ShowMore : messages.ShowLess }}
                            </a>
                            @if (isCloseIconEnabled && !emergencyMessageClosed) {
                                <a class="link-external handle-content" href="" [vnDynamicHtml]="messages.OkText" (click)="closeEmergencyMsg()"></a>
                            }
                        </div>
                        <div [hidden]="!hideShowMore">
                            @if (isCloseIconEnabled && !emergencyMessageClosed) {
                                <a class="link-external handle-content" href="" [vnDynamicHtml]="messages.OkText" (click)="closeEmergencyMsg()"></a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (optionsScreen) {
            <div>
                <pt-contact-options
                    [HccArticle]="HccArticle"
                    [HccCategory]="HccCategory"
                    [contactData]="initData"
                    [currentSelectedSubCategory]="currentSelectedSubCategory"
                    [desktopContactUs]="showContactUsHomepage"
                    [faqLink]="faqLink"
                    [helpAndContactData]="helpAndContactData"
                    [optionsScreen]="optionsScreen"
                    [selectedCategory]="currentSelectedCategory"
                    [showEmail]="showEmail"
                    [showPhone]="showPhone"
                    [twitterLink]="twitterLink"
                    (onEmailScreenLoad)="emailScreenLoad($event)"
                    (onEmailSelected)="enableEmailScreen($event)"
                    (onPhoneSelected)="enablePhoneScreen($event)">
                </pt-contact-options>
            </div>
        }
        <!-- <div class="main-heading">{{headerTitle}}</div> -->
        @if (!optionsScreen) {
            <div>
                <!-- Commented un-used code + it creates circular dependency -->
                <!-- @if (!hideRemaining && showSearch) {
                    <div>
                        @if (!hideFirstLevel || !hideThirdLevel) {
                            <pt-contact-page-search
                                class="searchbox"
                                [initData]="initData"
                                [ngClass]="{ 'help-search-area': !hideThirdLevel && isDesktop }">
                            </pt-contact-page-search>
                        }
                    </div>
                } -->
                @if (Data && showContactUsHomepage && showContactUsOnTop) {
                    <div class="user-menu" [hidden]="hideFirstLevel || hideRemaining">
                        <div class="contact-header-title">
                            <div class="focus-contact-sub-heading">
                                {{ messages?.ContactOurCustomerSupportDirectly }}
                            </div>
                        </div>
                        <div class="help-table-border">
                            <div class="user-menu-item">
                                <ng-container *ngTemplateOutlet="contactUsTemplate"></ng-container>
                            </div>
                        </div>
                    </div>
                }
                <div class="user-menu-wrapper">
                    @if (initData.enablePromoCTA && showpromocta && isMobile) {
                        <div class="cta-promo-mobile">
                            <div>
                                <button class="oval-link" (click)="promoctaEvent()"><i class="theme-offers-2"></i>{{ promoctalabel }}</button>
                            </div>
                        </div>
                    }
                    @if (Data) {
                        <div class="user-menu" [hidden]="hideFirstLevel">
                            <div [hidden]="hideRemaining">
                                @if (popularArticlesData.length > 0) {
                                    <div class="focus-contact-sub-heading header-margin" [hidden]="!showpopularArticles">
                                        {{ messages?.PopularArticles }}
                                    </div>
                                }
                                <div class="help-table-border">
                                    @for (item of popularArticlesData; track i; let i = $index) {
                                        <div class="user-menu-item">
                                            <div class="user-menu-item-click" (click)="bindsubcategory(item, true, i + 1)">
                                                <div class="user-menu-item-middle-content">
                                                    <div class="content-header">
                                                        {{ item.child.faqTitle }}
                                                    </div>
                                                </div>
                                                <div class="user-menu-item-end-icon">
                                                    <span class="theme-right"></span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            @if (isMobile && Data.newCategoriesList.length > 0) {
                                <div class="focus-contact-sub-heading header-margin" [hidden]="hideRemaining">
                                    {{ messages?.PopularTopics }}
                                </div>
                            }
                            @if (isDesktop && Data.newCategoriesList.length > 0) {
                                <div class="focus-contact-sub-heading header-margin">
                                    {{ messages?.AllTopics }}
                                </div>
                            }
                            <div class="help-table-border">
                                @for (item of Data.newCategoriesList; track item.id; let i = $index) {
                                    <div class="user-menu-item">
                                        <div class="user-menu-item-click" (click)="bindcategory(item, 0, i + 1)">
                                            @if (attributes) {
                                                <div class="user-menu-item-start-icon">
                                                    <span
                                                        class="{{ attributes[item?.id] }}"
                                                        [ngClass]="{ 'icon-bg-round': initData.enableColorForCategories }"></span>
                                                </div>
                                            }
                                            <div class="user-menu-item-middle-content" [ngClass]="{ 'pl-2': initData.enableColorForCategories }">
                                                <div class="content-header">
                                                    {{ item.category.parent.title }}
                                                </div>
                                                <div class="content-desc">
                                                    {{ item.category.parent.text }}
                                                </div>
                                            </div>
                                            <div class="user-menu-item-end-icon">
                                                <span class="theme-right"></span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    @if ((isDesktop && showContactUsHomepage && !showContactUsOnTop) || isMobile) {
                        <div class="contact-header-title" [hidden]="hideRemaining">
                            @if (!hideFirstLevel) {
                                <div class="focus-contact-sub-heading">
                                    {{ messages?.CantFindWhatYouAreLookingFor }}
                                </div>
                            }
                        </div>
                    }
                    @if (Data) {
                        <div class="user-menu" [hidden]="hideFirstLevel || hideRemaining">
                            <div class="help-table-border">
                                @if (isMobile) {
                                    <div class="user-menu-item">
                                        <div class="user-menu-item-click" (click)="BrowseAll()">
                                            <div class="user-menu-item-middle-content">
                                                <div class="content-header">
                                                    {{ messages?.BrowseAllHelpTopics }}
                                                </div>
                                            </div>
                                            <div class="user-menu-item-end-icon">
                                                <span class="theme-right"></span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (showContactUsHomepage && !showContactUsOnTop) {
                                    <div class="user-menu-item">
                                        <ng-container *ngTemplateOutlet="contactUsTemplate"></ng-container>
                                    </div>
                                }
                                @if (
                                    initData.enableGreeceComplaintForm && ((isDesktop && showContactUsHomepage && !showContactUsOnTop) || isMobile)
                                ) {
                                    <div class="user-menu-item">
                                        <div class="user-menu-item-click" (click)="goToComplaintForm()">
                                            @if (isDesktop) {
                                                <div [vnDynamicHtml]="messages?.ComplaintFormIconTag"></div>
                                            }
                                            <div class="user-menu-item-middle-content">
                                                <div class="content-header">
                                                    {{ messages?.ComplaintFormTitle }}
                                                </div>
                                            </div>
                                            <div class="user-menu-item-end-icon">
                                                <span class="theme-right"></span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
                <div class="user-menu-wrapper" [ngClass]="{ 'help-search-area': !hideThirdLevel && !isMobile }">
                    @if (secondLevelData) {
                        <div class="user-menu" [hidden]="hideSecondLevel">
                            <div class="help-table-border">
                                @for (item of secondLevelData; track i; let i = $index) {
                                    <div class="user-menu-item">
                                        <div id="{{ item.title }}"></div>
                                        <div class="user-menu-item-click" (click)="bindsubcategory(item, false, i + 1)">
                                            <div class="user-menu-item-middle-content">
                                                <div class="content-header">
                                                    {{ item.title }}
                                                </div>
                                            </div>
                                            <div class="user-menu-item-end-icon">
                                                <span class="theme-right"></span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
                @if (showPlayer) {
                    <div>
                        @if (thirdLevelData) {
                            <div class="contact-video" [hidden]="hideThirdLevel">
                                @if (isDesktop) {
                                    <div class="thirdleveltitle" [innerHtml]="thirdLevelData.value.copyTitle"></div>
                                }
                                <div
                                    #contactimagevideo
                                    class="desc-txt"
                                    [ngClass]="{
                                        'click-link-interaction': !darkModeService.isEnabled,
                                        'click-link-interaction-dark': darkModeService.isEnabled,
                                    }"
                                    [vnDynamicHtml]="thirdLevelData.value.copy"></div>
                                @if (!loggedInUser && !enableLoginButtonPhase3) {
                                    <div class="pc-txt" [innerHtml]="content.messages!.LoginText"></div>
                                }
                                @if (initData.showNewDocumentUploadOption && thirdLevelData.value.preFooterContent) {
                                    <div class="additional-content">
                                        <div class="mt-3 documenttext" id="newdocUploadCard">
                                            <div class="card--clickable card-bg bonus-card">
                                                <div [vnDynamicHtml]="thirdLevelData.value.preFooterContent"></div>
                                                <div class="button-bottom-margin" [ngClass]="{ 'text-center': !this.isMobile }">
                                                    <button
                                                        class="btn btn-primary"
                                                        type="button"
                                                        [innerHTML]="thirdLevelData.value.preFooterButton"
                                                        [ngClass]="{ 'w-50': !isMobile, 'w-100': isMobile }"
                                                        (click)="goToDocumentUpload(thirdLevelData)"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <p
                                    class="helptext"
                                    [innerHtml]="content.messages!.MoreHelpText"
                                    [ngClass]="{ 'mt-3': !(initData.showNewDocumentUploadOption && thirdLevelData.value.preFooterContent) }"></p>
                                <div class="help-btns" id="helpcontact-buttons">
                                    <a
                                        class="btn de-emphasize w-50 mr-2"
                                        id="helpcontact-yesbtn"
                                        [ngClass]="{ 'btn-dark': darkModeService.isEnabled, 'btn-light': !darkModeService.isEnabled }"
                                        (click)="goToOptions(true)"
                                        >{{ initData.helpContactContent.messages.YesButton }}</a
                                    >
                                    <a
                                        class="btn de-emphasize w-50 ml-2"
                                        id="helpcontact-nobtn"
                                        [ngClass]="{ 'btn-dark': darkModeService.isEnabled, 'btn-light': !darkModeService.isEnabled }"
                                        (click)="close(false, false)"
                                        >{{ initData.helpContactContent.messages.NoButton }}</a
                                    >
                                </div>
                                <p class="pc-txt" [innerHtml]="thirdLevelData.value.footer" (click)="faqLinkClick($event)"></p>
                                @if (!loggedInUser && enableLoginButtonPhase3) {
                                    <div class="card card-bg bonus-card">
                                        <div class="portal-font-s1" id="card-header" [ngClass]="{ 'text-center': this.isMobile }">
                                            {{ content.messages!.LoginHeading }}
                                        </div>
                                        <div class="button-bottom-margin mt-3" [ngClass]="{ 'text-center': !this.isMobile }">
                                            <button
                                                class="btn"
                                                type="button"
                                                [ngClass]="{
                                                    'w-50': !isMobile,
                                                    'w-100': isMobile,
                                                    'btn-dark': darkModeService.isEnabled,
                                                    'btn-light': !darkModeService.isEnabled,
                                                }"
                                                (click)="goToLoginPage(thirdLevelData)">
                                                {{ content.messages!.LoginButton }}
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
        @if (showchathistory && !optionsScreen) {
            <div class="portal-center-wrapper content-width chatcard my-5" id="chathistory" (click)="goToHistory()">
                <div class="card card--clickable chathistorycard">
                    <div class="cursorPointer d-flex align-vertically">
                        <div class="{{ initData.chatHistoryContent.messages.class }} chatoption mr-3 ml-4"></div>
                        <div class="chatbonuscard option-font align-left m-2">
                            <div class="align-text-in-mobile m-3">
                                <div class="heading">{{ initData.chatHistoryContent.title }}</div>
                                <div class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0">
                                    <p>{{ initData.chatHistoryContent.messages.ChatHistory }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (!initData.contactusTilePosition || initData.contactusTilePosition == 'bottom') {
            <ng-container *ngTemplateOutlet="contactusTile"></ng-container>
        }
    </div>
</ng-template>
<ng-template #contactUsTemplate>
    <div class="user-menu-item-click" (click)="contactUsClick()">
        <div class="user-menu-item-middle-content">
            <div class="content-header">
                {{ contactUsTitle }}
            </div>
        </div>
        <div class="user-menu-item-end-icon">
            <span class="theme-right"></span>
        </div>
    </div>
</ng-template>
<ng-template #contactusTile>
    @if (!hideFirstLevel && !optionsScreen && initData.enableContactOptionsTile) {
        <div class="mt-3 d-flex" id="newdocUploadTxt">
            <ul
                class="newdocUploadTxt-ul newdocUploadTxt-md-ul newdocUploadTxt-ls-ul newdocUploadTxt-ls-li"
                [ngClass]="{ 'd-flex align-items-center justify-content-between': isDesktop }">
                <li class="newdocUploadTxt-li newdocUploadTxt-md-li">
                    <div class="docUploadContent pl-0">
                        <div class="to-heading" [ngClass]="{ 'font-size-16': isMobile && initData.contactusTilePosition == 'top' }">
                            {{ content.messages!.ContactSupport }}
                        </div>
                        <div
                            class="btm-heding"
                            [ngClass]="{
                                'font-size-12': isMobile && initData.contactusTilePosition == 'top',
                                'font-weight-500': initData.contactusTilePosition == 'top',
                            }">
                            {{ content.messages!.AvailableSupport }}
                        </div>
                    </div>
                </li>
                <li class="btn-li">
                    <button
                        class="theme-contact btn de-emphasize btn-primary"
                        type="button"
                        [ngClass]="{ 'mt-1': isMobile }"
                        (click)="goTocontactoption()">
                        {{ messages?.ContactUs }}
                    </button>
                </li>
            </ul>
        </div>
    }
</ng-template>
